export default {
    apiKey: 'AIzaSyDpZfv35UyfAy8NJf0bJPSsDd7QKQpvQg0',
    clientId: '397005446893-is5u1c5str9iim5stsmht0vlenpan8if.apps.googleusercontent.com',
    discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
    scope: 'https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtubepartner'
}
